import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { JsonUpdatePartial } from '@elotech/angular-common';
import { AuthHttp } from '@elotech/angular-common';
import { HttpClient } from '@elotech/angular-common';
import { Usuario, UsuarioTrocaSenha } from '@elotech/angular-common';
import { EntityService } from '@elotech/angular-common';
import { RolesUsuarioDTO } from './role.type';

@Injectable()
export class UsuarioService extends EntityService<Usuario> {
  constructor(public httpClient: HttpClient, private authHttp: AuthHttp) {
    super(httpClient);
    this.resource = '/rest/usuarios';
    this.fields = [
      'id',
      'usuario',
      'email',
      'nome',
      'cargo',
      'cpf',
      'ativo',
      'contaBloqueada',
      'senhaExpirada',
      'modoAutenticacao',
      'rg.numero',
      'rg.dataEmissao',
      'rg.orgaoEmissor',
      'rg.uf.id',
      'rg.uf.sigla',
      'usuarioResponsavel.id',
      'usuarioResponsavel.nome',
      'rg.uf.descricao',
      'dataExpiracao',
      'matricula',
      'modulos.id',
      'modulos.modulo.id',
      'modulos.modulo.descricao',
      'modulos.modulo.path',
      'modulos.modulo.url',
      'grupos.nome',
      'usuarioRecursos.nome',
      'entidades.id',
      'entidades.entidade.nome',
      'entidades.entidade.id'
    ];
  }

  public getUsuarioLogado(): Observable<Usuario> {
    return this.authHttp.getUsuarioLogado();
  }

  public trocarSenha(
    id: number,
    usuarioTrocaSenha: UsuarioTrocaSenha
  ): Observable<UsuarioTrocaSenha> {
    const requestParams = {
      resource: `${this.resource}/changePassword/${id}`,
      body: usuarioTrocaSenha
    };
    return this.httpClient.patch(requestParams);
  }

  public definePassword(
    id: number,
    usuarioTrocaSenha: UsuarioTrocaSenha
  ): Observable<UsuarioTrocaSenha> {
    const requestParams = {
      resource: `${this.resource}/definePassword/${id}`,
      body: usuarioTrocaSenha
    };
    return this.httpClient.patch(requestParams);
  }

  public atualizarDados(usuario: Usuario): Observable<Usuario> {
    const jsonPatchNome: JsonUpdatePartial = JsonUpdatePartial.replace(
      usuario.nome,
      'nome'
    );
    const jsonPatchEmail: JsonUpdatePartial = JsonUpdatePartial.replace(
      usuario.email,
      'email'
    );

    const requestParams = {
      resource: `${this.resource}/${usuario.id}`,
      body: [jsonPatchNome, jsonPatchEmail]
    };

    return this.httpClient.patch(requestParams);
  }
}
